import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        selectShippingOption: false,
        loggedInUser: false,
        checkSession: true,
        sessionStartTime: '',
        loginSession15MinLeft: 1000,
        loginSessionTimeLeft: '',
        sessionChecker: '',
        transportationType: "export",
        calculatorState: "initial",
        uniqueOrderNumber: undefined,
        inClientAdmin: false,
        shippingTabLevel: 1,
        currentLevel: 1,
        direction: null,
        addressSelectorType: "user",
        defaultAddressSelector: true,
        $routes: {},
        countriesList: {},
        copied: false,
        quickEditDimensions: false,
        returnedBackFromPayment: false,
        selectedShippingType: "export",
        selectedFormType: "single",
        clientId: null,
        temporaryClientDiscounts: {},
        temporaryDetailedCosts: null,
        courierAlreadyCalled: false,
        manualDiscounts: {
            transportation: "",
            privateAddress: "",
            extendedArea: "",
            additionalHandling: "",
        },
        voucherCode: "",
        customValues: {
            letterSwapped: false,
            lockedToCountry: false,
        },
        checkOutSteps: {
            first: false,
            second: false,
            third: false,
            fourth: false,
            fifth: false,
            six: false,
            seven: false,
        },
        currentActions: {
            gettingShippingOptions: false,
            editingPackages: false,
        },
        from: {
            countryName: "Lietuva",
            country: "lt",
            countryBackgroundImage: "",
            postCode: undefined,
            countryId: undefined,
        },
        to: {
            countryName: "",
            country: "",
            countryBackgroundImage: "",
            postCode: undefined,
            countryId: undefined,
        },
        packageType: "02",
        packagesDimensions: [
            {
                weight: 0.5,
                length: 1,
                width: 1,
                height: 1,
                insurance: "",
            },
        ],
        shipperAddressInformation: {
            companyOrSender: "",
            contactPerson: "",
            phone: "",
            email: "",
            address1: "",
            address2: "",
            address3: "",
            city: "",
            stateOrProvince: "",
            saveLikeNewAddress: false,
        },
        deliveryAddressInformation: {
            companyOrSender: "",
            contactPerson: "",
            phone: "",
            email: "",
            address1: "",
            address2: "",
            address3: "",
            city: "",
            stateOrProvince: "",
            saveLikeNewAddress: false,
        },
        otherDeliveryInformation: {
            isDocuments: false,
            hasBatteries: false,
            description: "",
            registrationNumber: "",
            insuranceDeclaredValue: "",
            notifications: false,
            requireSignature: false,
            directDelivery: false,
            cashOnDelivery: false,
            saturdayDelivery: false,
            adultSignature: false,
            iscBio: false,
            iscOther: false,
            commercialInvoiceType: "",
            invoiceTotal: "",
            invoiceCurrency: "",
            cashAmount: "",
            cashCurrency: "",
            senderAboutParcelEmail: false,
            senderAboutPackagePickupEmail: false,
            senderAboutExceptionsEmail: false,
            senderAboutParcelDeliveryEmail: false,
            receiverAboutParcelEmail: false,
            receiverAboutPackagePickupEmail: false,
            receiverAboutExceptionsEmail: false,
            receiverAboutParcelDeliveryEmail: false,
            otherAboutParcelEmail: false,
            otherAboutPackagePickupEmail: false,
            otherAboutExceptionsEmail: false,
            otherAboutParcelDeliveryEmail: false,
            otherNotificationsEmail: "",
            packageValueDiff: false,
            registrationNumberSelected: false,
            voecVatRegistration: "",
            pvaRegistration: "",
            saveVoecOrPvaCode: false,
        },
        carrierInfo: {
            callCarrier: 1,            
            carrierDate: "",
            carrierTimeFrom: "",
            carrierTimeTo: "",
            differentAddress: 0,
            differentAddressInfo: {
                address1: "",
                address2: "",
                address3: "",
                city: "",
                state: "",
                county: "",
                province: "",
                postCode: "",
            },
            invoiceDeliveryType: "pdf",
            notesToCarrier: "",
            pickUpCode: "",
        },
        selectedShippingOption: {},        
        selectShippingService: true,
        availableShippingOptions: [],
        awaitingActions: {
            shippingOptionsWereReset: false,
            resetShippings: false,
            getSearchOptions: false,
            selectNewOption: false,
            hasSameService: true,
            reselectCountries: {
                from: false,
                to: false,
            },
            refreshStateOrProvince: {
                shipperAddressInformation: false,
                deliveryAddressInformation: false,
            },
            forceUpdate: {
                initialCalculatorForm: false,
            },
            getNewPickupTimes: 0,
        },
        uploadedFiles: {
            commercialInvoiceAttachments: [],
            commercialInvoiceModal: [],
        },
        majorPaymentType: "prepaid",
        paymentOption: "",
        commercialInvoiceModal: {
            commercialInvoiceCondition: "",
            commercialInvoiceExportReason: "",
            commercialInvoiceCurrency: "",
            receiverTaxNumber: "",
            declaration:
                "I hereby certify that the information on this invoice is true and correct and the contents and value of this shipment is as stated above.",
            description: "",
            sameInvoiceAddress: 1,
            differentAddress: {
                companyOrSender: "",
                contactPerson: "",
                phone: "",
                email: "",
                city: "",
                address1: "",
                address2: "",
                address3: "",
                countryCode: "",
                postCode: "",
                stateOrProvince: "",
            },
            products: [
                {
                    description: "",
                    tariffCode: "",
                    countryOfOrigin: "",
                    count: "",
                    unitPrice: "",
                },
            ],
        },
        detailedCosts: {
            baseCost: 0,
            fuelCharges: 0,
            otherCharges: [],
            totalCost: 0,
            vat: 0,
            totalCostWithVat: 0,
        },
        userAddresses: {},
        additionalAddressInfo: {},
        pickupInformation: {
            postCode: "",
            country: "",
            latestOrderTime: "",
            earliestPickupTime: "",
            latestPickupTime: "",
            minimumInterval: "",
        },
        differentPaymentInformation: {
            payer: "sender",
            payerPostCode: "",
            payerCountry: "",
            payerCode: "",
            importPayer: "receiver",
            importPayerPostCode: "",
            importPayerCountry: "",
            importPayerCode: "",
        },
        importInformation: {
            email: "",
            notes: "",
            sendNotification: false,
            notificationEmail: "",
            labelType: "print",
        },
        unregisteredCompanyInformation: {
            type: "",
            company: {
                companyName: "",
                companyCode: "",
                vatCode: "",
                registrationAddress: "",
                emailAddress: "",
                city: "",
                postCode: "",
                type: "",
            },
            person: {
                contactPerson: "",
                address: "",
                city: "",
                postCode: "",
                emailAddress: "",
            },
        },
        computed: {
            citiesArray: {
                to: [],
                from: [],
            },
        },
        massShipments: [],
        needCommercialInvoice: true,
        massShipmentsDetailedCosts: [],
        packageValue50k: false,
    },
    getters: {},
    mutations: {},
    actions: {},  
});
